import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

const checkoutFn = httpsCallable(functions, 'createCheckoutSession', { timeout: 30000 });
const portalFn   = httpsCallable(functions, 'createPortalSession',   { timeout: 30000 });

/**
 * Start a Stripe Checkout for the given planKey ('starter' | 'pro').
 * Redirects the current tab to Stripe Checkout on success.
 * Stripe will redirect back to /?upgraded=true after payment.
 */
export async function startCheckout(planKey) {
  const successUrl = `${window.location.origin}/?upgraded=true`;
  const cancelUrl  = `${window.location.origin}/`;
  const result = await checkoutFn({ planKey, successUrl, cancelUrl });
  window.location.href = result.data.url;
}

/**
 * Open the Stripe Customer Portal (cancel, update card, change plan).
 * Redirects the current tab to the portal.
 */
export async function openBillingPortal() {
  const returnUrl = window.location.origin;
  const result = await portalFn({ returnUrl });
  window.location.href = result.data.url;
}
